import { graphql } from 'react-relay/legacy';

export const sellerApplicationRoot = graphql`
    query sellerApplicationRootQuery($leadId: String!) {
        viewer {
            ...SellerApplicationWrapper_viewer
        }
    }
`;
